/* tslint:disable:jsx-no-lambda WI:47742 */
import * as React from 'react';
import type { CharmSuggestionsItem } from 'owa-calendar-charm-suggestions-data';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import StyledHoverElement from 'owa-component-styling-utils/lib/components/StyledHoverElement';
import { CharmControl, CharmControlColorPattern, CharmControlColorProps } from 'owa-charmcontrol';
import { getOptimalTextColorString } from 'owa-color-utils/lib/colorUtils';
import { getPalette, getPaletteAsRawColors } from 'owa-theme';

import classNames from 'classnames';
import styles from './CharmSuggestions.scss';

export interface CharmSuggestionRowProps {
    colorScheme: ColorScheme;
    charmSuggestionsItem: CharmSuggestionsItem;
    isHighlighted: boolean;
    onSelectIcon: (charmSuggestionsItem: CharmSuggestionsItem) => void;
}

export default function CharmSuggestionRow(props: CharmSuggestionRowProps) {
    const [charmIconPrimaryColor, setCharmIconPrimaryColor] = React.useState<string>(
        props.isHighlighted ? props.colorScheme.calDark : props.colorScheme.calPrimary
    );
    const [textColor, setTextColor] = React.useState<string>(
        props.isHighlighted ? getPalette().neutralDark : getPalette().neutralPrimary
    );
    const onHoverCallback = isHoverState => {
        // selected/hover state
        if (isHoverState || props.isHighlighted) {
            {
                setCharmIconPrimaryColor(props.colorScheme.calDark);
                setTextColor(getPalette().neutralDark);
            }
        } else {
            {
                setCharmIconPrimaryColor(props.colorScheme.calPrimary);
                setTextColor(getPalette().neutralPrimary);
            }
        }
    };
    // Sets up the color styles for the calendar color
    let { colorScheme, charmSuggestionsItem, onSelectIcon } = props;
    let hoverColor = getOptimalTextColorString(
        getPaletteAsRawColors().neutralPrimary,
        props.colorScheme,
        props.colorScheme.calLight
    );
    let highlightedColor = getOptimalTextColorString(
        getPaletteAsRawColors().neutralPrimary,
        props.colorScheme,
        props.colorScheme.calLighter
    );
    let finalColorProps: CharmControlColorProps = {
        colorPattern: CharmControlColorPattern.Normal,
        calDark: colorScheme.calDark,
        calDarkAlt: colorScheme.calDarkAlt,
        textColor: colorScheme.accessibleText.calPrimaryBackground,
        calPrimary: charmIconPrimaryColor,
    };
    return (
        <StyledHoverElement
            hoverColor={hoverColor}
            isHighlighted={props.isHighlighted}
            highlightedColor={highlightedColor}
            highlightedHoverColor={hoverColor}
            onHoverCallback={onHoverCallback}>
            <div
                className={classNames(styles.suggestionRow)}
                key={charmSuggestionsItem.keyword}
                onClick={() => onSelectIcon(charmSuggestionsItem)}>
                <div className={classNames(styles.charmIconContainer)}>
                    <CharmControl
                        iconId={charmSuggestionsItem.charm.IconId}
                        className={styles.charmIcon}
                        colorProps={finalColorProps}
                    />
                </div>
                <div className={styles.keywordText} style={{ color: textColor }}>
                    {charmSuggestionsItem.keyword}
                </div>
            </div>
        </StyledHoverElement>
    );
}
